import { URLS } from '@constants';

import { IAppStateJSON } from '@mobx';

import { getUserName } from './getUserName';
import { Log } from './Log';

export const getPageTitle = (
	t: (id: string, params?: { [key: string]: string }) => string,
	isRouteMatched: (url: string) => boolean,
	state: IAppStateJSON,
) => {
	const {
		albumsStore,
		artistsStore,
		playlistsStore,
		tracksStore,
		usersStore,
	} = state;
	let pageTitle = t('default');

	try {
		if (isRouteMatched(URLS.SHARE_ALBUM)) {
			if (albumsStore?.itemShare?.name) {
				pageTitle = `${albumsStore?.itemShare?.name}`;

				if (albumsStore?.itemShare?.artists?.length) {
					pageTitle += ' - ';
					pageTitle += albumsStore?.itemShare?.artists
						?.map((item) => item.name)
						.join(' • ');
				}
			}
		}

		if (isRouteMatched(URLS.SHARE_ARTIST)) {
			if (artistsStore?.itemShare?.name) {
				pageTitle = `${artistsStore?.itemShare?.name}`;
			}
		}

		if (isRouteMatched(URLS.SHARE_PLAYLIST)) {
			if (playlistsStore?.itemShare?.name) {
				pageTitle = `${playlistsStore?.itemShare?.name}`;
			}
		}

		if (isRouteMatched(URLS.SHARE_TRACK)) {
			if (tracksStore?.itemShare?.name) {
				pageTitle = `${tracksStore?.itemShare?.name}`;

				if (tracksStore?.itemShare?.artist?.name) {
					pageTitle += ` - ${tracksStore?.itemShare?.artist?.name}`;
				}
			}
		}

		if (isRouteMatched(URLS.SHARE_USER)) {
			if (usersStore?.itemShare) {
				pageTitle = getUserName(usersStore?.itemShare);
			}
		}
	} catch (err) {
		Log.error(`Failed build page title: ${err}`);
	}

	return pageTitle;
};
